// ── Cloudinary config ─────────────────────────────────────────
const QUOTE_CLOUDINARY_CLOUD  = 'depk6kisv';
const QUOTE_CLOUDINARY_PRESET = 'hello123';

// ── Print Services placeholder product ────────────────────────
// $1.00 each in Shopify Admin — quantity = total print+setup cost in dollars
const PRINT_SERVICE_VARIANT_ID = 47854657175739;

// ── DTF pricing (per piece, per print location) ───────────────
// Tier is picked from the total number of pieces in the order.
const DTF_SIZES = ['5 in x 5 in', '4 in x 12 in', '8 in x 12 in', '12 in x 12 in'];
const DTF_PRICE_TIERS = [
  { maxQty: 2,        prices: [22, 24, 28, 30] },
  { maxQty: 10,       prices: [15, 17.6, 18.5, 25] },
  { maxQty: Infinity, prices: [13, 15, 17.5, 22] },
];
function dtfPricePerPiece(size, totalQty) {
  const tier = DTF_PRICE_TIERS.find((t) => totalQty <= t.maxQty);
  const i = DTF_SIZES.indexOf(size);
  return tier.prices[i >= 0 ? i : 0];
}

// ── Screen printing pricing (per piece, per print location) ───
// prices[i] = price for (i + 1) ink colors. Tier is picked from total pieces.
const SP_PRICE_TIERS = [
  { maxQty: 11,       prices: [13,   15,   17,   20,   22,   25] },
  { maxQty: 23,       prices: [7,    8,    9.4,  10.5, 11.9, 12.7] },
  { maxQty: 49,       prices: [4,    5,    6,    7,    8.4,  9] },
  { maxQty: 71,       prices: [3.72, 4.65, 5.85, 6.51, 7.44, 8.37] },
  { maxQty: 149,      prices: [3.6,  4.5,  5.4,  6.3,  7.2,  8.1] },
  { maxQty: 199,      prices: [2.8,  3.1,  4,    5,    5.5,  6] },
  { maxQty: 399,      prices: [2.5,  2.6,  3.9,  4.6,  5.5,  5.8] },
  { maxQty: Infinity, prices: [1.99, 2.4,  3.7,  4.5,  4.9,  5] },
];
function spPricePerPiece(colorCount, totalQty) {
  const tier = SP_PRICE_TIERS.find((t) => totalQty <= t.maxQty);
  return tier.prices[Math.min(Math.max(colorCount, 1), 6) - 1];
}

class QuoteModal {
  constructor(el) {
    this.modal = el;
    this.sectionId = el.dataset.section;
    this.step = 1;
    this.totalSteps = 5;
    this._step1Quantities = {};  // { color: { size: qty } }
    this._printType = 'screen-printing';
    this._isWholesale = el.dataset.isWholesale === 'true';
    this._nnData = {};

    const dataEl = document.getElementById(`QuoteProductData-${this.sectionId}`);
    if (!dataEl) return;
    try {
      this.product = JSON.parse(dataEl.textContent);
    } catch {
      return;
    }

    el._quoteModal = this;
    this._bind();
  }

  _bind() {
    this.modal.querySelector('.quote-modal__close').addEventListener('click', () => this.close());
    this.modal.querySelector('.quote-modal__overlay').addEventListener('click', () => this.close());

    this.modal.addEventListener('click', (e) => {
      const action = e.target.closest('[data-quote-action]')?.dataset.quoteAction;
      if (action === 'next')      this._next();
      else if (action === 'prev') this._prev();
      else if (action === 'close') this.close();
      else if (action === 'addToCart') this._submit();
    });

    // N&N checkbox: auto-enable the location when N&N is checked
    this.modal.addEventListener('change', (e) => {
      if (!e.target.classList.contains('quote-location__names-numbers')) return;
      if (!e.target.checked) return;
      const locationCb = e.target.closest('.quote-location')?.querySelector('.quote-location__checkbox');
      if (locationCb && !locationCb.checked) locationCb.checked = true;
    });

    // Repeat order checkbox
    this.modal.addEventListener('change', (e) => {
      if (!e.target.classList.contains('quote-repeat__checkbox')) return;
      const details = document.getElementById(`QuoteRepeatInfo-${this.sectionId}`);
      if (details) details.style.display = e.target.checked ? 'block' : 'none';
    });

    // Artwork file upload
    this.modal.addEventListener('change', (e) => {
      if (!e.target.classList.contains('quote-location__file-input')) return;
      const file = e.target.files[0];
      if (!file) return;
      const card       = e.target.closest('.quote-location-detail');
      const filenameEl = card?.querySelector('.quote-location__filename');
      const uploadBtn  = card?.querySelector('.quote-location__upload-btn');

      if (QUOTE_CLOUDINARY_CLOUD && QUOTE_CLOUDINARY_PRESET) {
        if (filenameEl) { filenameEl.textContent = `Uploading ${file.name}…`; filenameEl.style.opacity = '0.65'; }
        if (uploadBtn)  uploadBtn.textContent = 'Uploading…';
        e.target.disabled = true;
        this._uploadFile(file)
          .then((url) => {
            e.target.dataset.uploadedUrl = url;
            if (filenameEl) { filenameEl.textContent = `✓ ${file.name}`; filenameEl.style.cssText = 'color:green;font-size:.8rem;'; }
            if (uploadBtn)  uploadBtn.textContent = 'Change File';
          })
          .catch(() => {
            if (filenameEl) { filenameEl.textContent = `✗ Upload failed — please try again`; filenameEl.style.cssText = 'color:red;font-size:.8rem;'; }
            if (uploadBtn)  uploadBtn.textContent = 'Upload Artwork (Optional)';
            e.target.value = '';
          })
          .finally(() => { e.target.disabled = false; });
      } else {
        if (filenameEl) { filenameEl.textContent = file.name; filenameEl.style.opacity = '0.65'; }
      }
    });

    // Names & numbers CSV upload
    this.modal.addEventListener('change', (e) => {
      if (!e.target.classList.contains('quote-nn__file')) return;
      const file = e.target.files[0];
      if (!file) return;
      const filenameEl = document.getElementById(`QuoteNNFilename-${this.sectionId}`);
      if (file.name.toLowerCase().endsWith('.csv')) {
        const reader = new FileReader();
        reader.onload = (ev) => {
          try {
            const data = this._parseCSV(ev.target.result);
            this._applyCSVToGrid(data);
            if (filenameEl) { filenameEl.textContent = `✓ ${file.name} — applied to grid`; filenameEl.style.cssText = 'color:green;font-size:.8rem;'; }
          } catch {
            if (filenameEl) { filenameEl.textContent = `✗ Could not parse CSV`; filenameEl.style.cssText = 'color:red;font-size:.8rem;'; }
          }
        };
        reader.readAsText(file);
      } else if (QUOTE_CLOUDINARY_CLOUD && QUOTE_CLOUDINARY_PRESET) {
        if (filenameEl) { filenameEl.textContent = `Uploading ${file.name}…`; filenameEl.style.opacity = '0.65'; }
        e.target.disabled = true;
        this._uploadFile(file)
          .then(url => { e.target.dataset.uploadedUrl = url; if (filenameEl) { filenameEl.textContent = `✓ ${file.name}`; filenameEl.style.cssText = 'color:green;font-size:.8rem;'; } })
          .catch(() => { if (filenameEl) { filenameEl.textContent = `✗ Upload failed`; filenameEl.style.cssText = 'color:red;font-size:.8rem;'; } })
          .finally(() => { e.target.disabled = false; });
      } else {
        if (filenameEl) filenameEl.textContent = file.name;
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.modal.getAttribute('aria-hidden') === 'false') this.close();
    });
  }

  open() {
    this.modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    this._step1Quantities = {};
    this._nnData = {};
    this._printType = 'screen-printing';

    // Reset location checkboxes (browser may restore)
    this.modal.querySelectorAll('.quote-location__names-numbers').forEach(cb => { cb.checked = false; });

    // Hide NN section
    const nnSection = document.getElementById(`QuoteNNSection-${this.sectionId}`);
    if (nnSection) {
      nnSection.classList.add('quote-nn-section--hidden');
      nnSection.style.setProperty('display', 'none', 'important');
    }

    this._prefillFromBulkPicker();
    this._buildStep1();
    this._goTo(1);
  }

  _prefillFromBulkPicker() {
    const picker = document.getElementById(`bulk-order-picker-${this.sectionId}`);
    if (!picker) return;

    const selectedSwatch = document.querySelector(
      `#image-swatches-wrapper-${this.sectionId} .image-swatch--selected`
    );
    const color = selectedSwatch?.dataset.color || '';

    const quantities = {};
    picker.querySelectorAll('.bulk-order-picker__input').forEach((input) => {
      const qty = parseInt(input.value) || 0;
      if (qty > 0) quantities[input.dataset.sizeValue] = qty;
    });

    if (Object.keys(quantities).length > 0) {
      this._step1Quantities[color] = quantities;
    }
  }

  close() {
    this.modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  _next() {
    if (this.step === 1) {
      this._flushStep1DOM();
      const totalQty = Object.values(this._step1Quantities)
        .flatMap(m => Object.values(m))
        .reduce((s, q) => s + q, 0);
      if (totalQty === 0) {
        this._showError('Please enter a quantity for at least one size.', 1);
        return;
      }
    }

    if (this.step === 2) {
      const any = [...this.modal.querySelectorAll('.quote-location__checkbox')].some(cb => cb.checked);
      if (!any) { this._showError('Please select at least one print location.', 2); return; }
      this._readPrintType();
      this._buildStep3();
    }

    if (this.step === 3) {
      this._buildStep4NN();
    }

    if (this.step === 4) {
      this._buildStep5();
    }

    if (this.step < this.totalSteps) this._goTo(this.step + 1);
  }

  _prev() {
    if (this.step > 1) this._goTo(this.step - 1);
  }

  _readPrintType() {
    const sel = document.getElementById(`QuotePrintType-${this.sectionId}`);
    this._printType = sel?.value || 'screen-printing';
  }

  _goTo(n) {
    this.step = n;
    this.modal.querySelectorAll('.quote-modal__step').forEach((s) => {
      s.hidden = parseInt(s.dataset.step) !== n;
    });
    this.modal.querySelectorAll('.quote-modal__dot').forEach((dot) => {
      dot.classList.toggle('active', parseInt(dot.dataset.dot) <= n);
    });
    this.modal.querySelector('.quote-modal__container').scrollTop = 0;
    this._clearError();
  }

  // ── Validation helpers ──────────────────────────────────────────

  _showError(msg, step) {
    const stepEl = this.modal.querySelector(`[data-step="${step || this.step}"]`);
    if (!stepEl) return;
    let err = stepEl.querySelector('.quote-modal__error');
    if (!err) {
      err = document.createElement('div');
      err.className = 'quote-modal__error';
      stepEl.querySelector('.quote-modal__step-footer').prepend(err);
    }
    err.textContent = msg;
    err.classList.add('visible');
  }

  _clearError() {
    this.modal.querySelectorAll('.quote-modal__error').forEach((e) => e.classList.remove('visible'));
  }

  // ── Step 1: Color swatches + size quantity grid ─────────────────

  _shopifyImgSize(src, size) {
    if (!src) return '';
    return src.replace(/(\.[^.?#]+)(\?|#|$)/, `_${size}$1$2`);
  }

  _buildStep1() {
    const body = document.getElementById(`QuoteColorQtyBody-${this.sectionId}`);
    if (!body) return;

    const { variants, size_option_index, color_option_index } = this.product;
    const sizes  = [...new Set(variants.map((v) => v.options[size_option_index]).filter(Boolean))];
    const colors = [...new Set(variants.map((v) => v.options[color_option_index]).filter(Boolean))];

    const colorImageMap = {};
    variants.forEach((v) => {
      const color = v.options[color_option_index];
      if (color && !colorImageMap[color]) {
        const src = v.featured_image?.src;
        colorImageMap[color] = src ? this._shopifyImgSize(src, '100x100_crop_center') : '';
      }
    });

    const renderSizeGrid = (activeColor) => {
      const saved = this._step1Quantities[activeColor || ''] || {};
      return sizes.map((size) => {
        const variant  = this._findVariant(size, activeColor);
        if (!variant) return '';
        const savedQty = saved[size] || 0;
        return `<div class="quote-size-item">
          <span class="quote-size-item__label">${size}</span>
          <input
            type="number"
            class="quote-size-item__input"
            min="0"
            value="${savedQty}"
            inputmode="numeric"
            data-variant-id="${variant.id}"
            data-size="${size}"
            data-color="${this._esc(activeColor || '')}"
            data-price="${variant.price}"
            aria-label="${activeColor ? this._esc(activeColor) + ' ' : ''}${size} quantity"
            ${savedQty > 0 ? 'style="border-color:rgb(var(--color-button))"' : ''}
          >
        </div>`;
      }).join('');
    };

    const saveGrid = () => {
      const wrapper = body.querySelector('[data-active-color]');
      const color = wrapper?.dataset.activeColor || '';
      if (!this._step1Quantities[color]) this._step1Quantities[color] = {};
      body.querySelectorAll('.quote-size-item__input').forEach((inp) => {
        this._step1Quantities[color][inp.dataset.size] = parseInt(inp.value) || 0;
      });
    };

    const switchColor = (newColor) => {
      saveGrid();
      body.querySelectorAll('.image-swatch').forEach((s) => s.classList.remove('image-swatch--selected'));
      body.querySelector(`.image-swatch[data-color="${CSS.escape(newColor)}"]`)?.classList.add('image-swatch--selected');
      const wrapper = body.querySelector('[data-active-color]');
      if (wrapper) wrapper.dataset.activeColor = newColor;
      body.querySelector('.quote-step2-color-name').textContent = newColor;
      body.querySelector('.quote-step2-grid').innerHTML = renderSizeGrid(newColor);
    };

    const firstColor = colors[0] || null;

    if (colors.length > 1) {
      const swatchButtons = colors.map((color) => {
        const img = colorImageMap[color];
        return `<button type="button"
          class="image-swatch${color === firstColor ? ' image-swatch--selected' : ''}"
          data-color="${this._esc(color)}"
          aria-label="${this._esc(color)}"
          title="${this._esc(color)}"
          ${img ? `style="background-image:url('${img}')"` : ''}
        ></button>`;
      }).join('');

      body.innerHTML = `
        <div class="image-swatches-wrapper" data-active-color="${this._esc(firstColor)}">
          <label class="form__label image-swatches__label">
            Color: <span class="quote-step2-color-name">${this._esc(firstColor)}</span>
          </label>
          <div class="image-swatches">${swatchButtons}</div>
        </div>
        <div class="quote-step2-grid">${renderSizeGrid(firstColor)}</div>`;

      body.querySelector('.image-swatches').addEventListener('click', (e) => {
        const btn = e.target.closest('.image-swatch');
        if (btn) switchColor(btn.dataset.color);
      });
    } else {
      body.innerHTML = `<div class="quote-step2-grid">${renderSizeGrid(firstColor)}</div>`;
    }

    body.addEventListener('input', (e) => {
      if (!e.target.classList.contains('quote-size-item__input')) return;
      const v = parseInt(e.target.value) || 0;
      e.target.style.borderColor = v > 0 ? 'rgb(var(--color-button))' : '';
      const color = e.target.dataset.color || '';
      const size  = e.target.dataset.size;
      if (!this._step1Quantities[color]) this._step1Quantities[color] = {};
      this._step1Quantities[color][size] = v;
    });
  }

  _flushStep1DOM() {
    const body = document.getElementById(`QuoteColorQtyBody-${this.sectionId}`);
    if (!body) return;
    const wrapper = body.querySelector('[data-active-color]');
    const color = wrapper?.dataset.activeColor || '';
    if (!this._step1Quantities[color]) this._step1Quantities[color] = {};
    body.querySelectorAll('.quote-size-item__input').forEach((inp) => {
      this._step1Quantities[color][inp.dataset.size] = parseInt(inp.value) || 0;
    });
  }

  // ── Step 3: Per-location artwork + color count cards ─────────────

  _buildStep3() {
    const body = document.getElementById(`QuoteArtworkBody-${this.sectionId}`);
    if (!body) return;

    const isDTF = this._printType === 'dtf';
    const checkedLocs = [...this.modal.querySelectorAll('.quote-location')]
      .filter(loc => loc.querySelector('.quote-location__checkbox').checked)
      .map(loc => loc.querySelector('.quote-location__checkbox').value);

    body.innerHTML = checkedLocs.map(locName => {
      const colorOptions = [1,2,3,4,5,6].map(i => `<option value="${i}">${i} Color${i > 1 ? 's' : ''}</option>`).join('');
      return `<div class="quote-location-detail" data-location="${this._esc(locName)}">
        <h4 class="quote-location-detail__title">${this._esc(locName)}</h4>
        ${!isDTF ? `
        <div class="quote-field">
          <label class="quote-field__label">Number of Ink Colors</label>
          <select class="quote-location__color-count--sp quote-field__select">${colorOptions}</select>
        </div>` : `
        <div class="quote-field">
          <label class="quote-field__label">Print Size</label>
          <select class="quote-location__dtf-size quote-field__select">${DTF_SIZES.map(s => `<option value="${s}">${s}</option>`).join('')}</select>
        </div>`}
        <div class="quote-field">
          <label class="quote-field__label">Artwork <span class="quote-field__optional">(Optional)</span></label>
          <label class="quote-location__upload-label">
            <input type="file" accept=".ai,.eps,.pdf,.png,.jpg,.jpeg,.svg" class="quote-location__file-input">
            <span class="quote-location__upload-btn">Upload Artwork</span>
          </label>
          <div class="quote-location__filename"></div>
        </div>
      </div>`;
    }).join('');
  }

  // ── Step 4: N&N data entry ──────────────────────────────────────

  _buildStep4NN() {
    const section   = document.getElementById(`QuoteNNSection-${this.sectionId}`);
    const grid      = document.getElementById(`QuoteNNGrid-${this.sectionId}`);
    const locsLabel = document.getElementById(`QuoteNNLocsLabel-${this.sectionId}`);
    if (!section) return;

    const nnLocs = this._getLocations().filter(l => l.namesNumbers);

    if (nnLocs.length === 0) {
      section.classList.add('quote-nn-section--hidden');
      section.style.setProperty('display', 'none', 'important');
      return;
    }

    section.classList.remove('quote-nn-section--hidden');
    section.style.removeProperty('display');

    if (locsLabel) locsLabel.textContent = `Adding names/numbers to: ${nnLocs.map(l => l.name).join(', ')}`;

    if (!grid) return;

    const rows = [];
    const colors = Object.keys(this._step1Quantities).filter(c => {
      return Object.values(this._step1Quantities[c] || {}).some(q => q > 0);
    });
    const hasMultiColor = colors.length > 1;

    Object.entries(this._step1Quantities).forEach(([color, sizeMap]) => {
      Object.entries(sizeMap).forEach(([size, qty]) => {
        if (!qty) return;
        for (let i = 0; i < qty; i++) {
          rows.push({ color, size, rowId: `${color}||${size}||${i}` });
        }
      });
    });

    if (rows.length === 0) {
      grid.innerHTML = '<p style="opacity:.6;font-size:.875rem;margin:0;">No quantities entered yet — go back to Step 1.</p>';
      return;
    }

    let hdr = `<tr><th class="quote-nn__th">#</th>`;
    if (hasMultiColor) hdr += `<th class="quote-nn__th">Color</th>`;
    hdr += `<th class="quote-nn__th">Size</th>`;
    nnLocs.forEach(l => { hdr += `<th class="quote-nn__th">${this._esc(l.name)}</th>`; });
    hdr += `</tr>`;

    let bodyHtml = '';
    rows.forEach((row, idx) => {
      const saved = this._nnData[row.rowId] || {};
      bodyHtml += `<tr class="quote-nn__tr">`;
      bodyHtml += `<td class="quote-nn__td quote-nn__td--num">${idx + 1}</td>`;
      if (hasMultiColor) bodyHtml += `<td class="quote-nn__td">${this._esc(row.color)}</td>`;
      bodyHtml += `<td class="quote-nn__td quote-nn__td--size">${this._esc(row.size)}</td>`;
      nnLocs.forEach(l => {
        const val = saved[l.name] || '';
        bodyHtml += `<td class="quote-nn__td"><input
          type="text"
          class="quote-nn__input"
          data-row-id="${this._esc(row.rowId)}"
          data-location="${this._esc(l.name)}"
          value="${this._esc(val)}"
          placeholder="Name or #"
          aria-label="${this._esc(l.name)} for ${this._esc(row.size)} row ${idx + 1}"
        ></td>`;
      });
      bodyHtml += `</tr>`;
    });

    grid.innerHTML = `<div class="quote-nn__table-wrap"><table class="quote-nn__table"><thead>${hdr}</thead><tbody>${bodyHtml}</tbody></table></div>`;

    grid.querySelectorAll('.quote-nn__input').forEach(inp => {
      inp.addEventListener('input', () => {
        const rid = inp.dataset.rowId;
        const loc = inp.dataset.location;
        if (!this._nnData[rid]) this._nnData[rid] = {};
        this._nnData[rid][loc] = inp.value;
      });
    });
  }

  // ── Step 5: Summary ─────────────────────────────────────────────

  _buildStep5() {
    const body     = document.getElementById(`QuoteSummaryBody-${this.sectionId}`);
    const totalsEl = document.getElementById(`QuoteTotals-${this.sectionId}`);
    if (!body || !totalsEl) return;

    const p      = this._calcPricing();
    const isDTF  = this._printType === 'dtf';

    if (p.items.length === 0) {
      body.innerHTML = '<p style="opacity:.6;font-size:.875rem;">No quantities entered — go back and add sizes.</p>';
      totalsEl.innerHTML = '';
      return;
    }

    const rows = p.items.map((i) => {
      const unit = (i.price / 100);
      return `<tr>
        <td>${i.color ? `${this._esc(i.color)} / ` : ''}${this._esc(i.size)}</td>
        <td class="text-right">${i.quantity}</td>
        <td class="text-right">$${unit.toFixed(2)}</td>
        <td class="text-right">$${(unit * i.quantity).toFixed(2)}</td>
      </tr>`;
    }).join('');

    const locSummary = p.locations.map((l) => {
      let artwork = '';
      if (l.fileUrl)       artwork = ` — <a href="${l.fileUrl}" target="_blank" rel="noopener" style="word-break:break-all">${this._esc(l.filename || 'View artwork')}</a>`;
      else if (l.filename) artwork = ` — ${this._esc(l.filename)}`;
      const colorInfo = isDTF ? `: ${this._esc(l.dtfSize)}` : `: ${l.colorCount} color${l.colorCount > 1 ? 's' : ''}`;
      const placement = l.placement ? ` (${this._esc(l.placement)})` : '';
      const wb        = l.whiteBase ? ' <span style="color:#1a4a7a;font-size:.75rem;">+ White Base</span>' : '';
      return `${this._esc(l.name)}${placement}${colorInfo}${wb}${artwork}`;
    }).join('<br>');

    const designName = document.getElementById(`QuoteDesignName-${this.sectionId}`)?.value?.trim() || '';

    body.innerHTML = `
      <div class="quote-summary">
        ${designName ? `<p style="font-weight:600;margin-bottom:4px;">${this._esc(designName)}</p>` : ''}
        <p style="font-size:.8rem;opacity:.7;margin-bottom:4px;">Print method: <strong>${isDTF ? 'DTF (Direct to Film)' : 'Screen Printing'}</strong></p>
        <div class="quote-summary__locations" style="margin-bottom:12px;">${locSummary}</div>
        <table class="quote-summary__table">
          <thead><tr>
            <th>Item</th>
            <th class="text-right">Qty</th>
            <th class="text-right">Unit</th>
            <th class="text-right">Line</th>
          </tr></thead>
          <tbody>${rows}</tbody>
        </table>
      </div>`;

    const printLabel = isDTF
      ? `DTF Print ($${p.printCostPerPiece.toFixed(2)}/pc × ${p.totalQty})`
      : `Printing ($${p.printCostPerPiece.toFixed(2)}/pc × ${p.totalQty})`;

    totalsEl.innerHTML = `
      <div class="quote-totals__row">
        <span>Garments</span>
        <span>$${p.garmentCost.toFixed(2)}</span>
      </div>
      <div class="quote-totals__row">
        <span>${printLabel}</span>
        <span>$${p.printCostTotal.toFixed(2)}</span>
      </div>
      ${p.setupCost > 0 ? `
      <div class="quote-totals__row">
        <span>Setup fee</span>
        <span>$${p.setupCost.toFixed(2)}</span>
      </div>` : ''}
      ${p.whiteBaseCost > 0 ? `
      <div class="quote-totals__row">
        <span>White Base (${p.whiteBaseLocs} location${p.whiteBaseLocs > 1 ? 's' : ''} × $1/pc × ${p.totalQty})</span>
        <span>$${p.whiteBaseCost.toFixed(2)}</span>
      </div>` : ''}
      ${p.nnCost > 0 ? `
      <div class="quote-totals__row">
        <span>Names &amp; Numbers (${p.nnLocCount} side${p.nnLocCount > 1 ? 's' : ''} × $10/pc × ${p.totalQty})</span>
        <span>$${p.nnCost.toFixed(2)}</span>
      </div>` : ''}
      ${p.discountAmount > 0 ? `
      <div class="quote-totals__row quote-totals__row--discount">
        <span>Bulk Discount (${(p.garmentDiscount * 100).toFixed(0)}% off ${p.totalQty} pcs)</span>
        <span>−$${p.discountAmount.toFixed(2)}</span>
      </div>` : ''}
      <div class="quote-totals__row quote-totals__row--total">
        <span><strong>Estimated Total</strong></span>
        <span><strong>$${p.subtotal.toFixed(2)}</strong></span>
      </div>
      <p class="quote-totals__note">* Final price confirmed upon order review</p>`;
  }

  // ── Data accessors ──────────────────────────────────────────────

  _getLocations() {
    // Base info (checkbox, placement, N&N) from step 2 location cards
    const step2Locs = [...this.modal.querySelectorAll('.quote-location')]
      .filter(loc => loc.querySelector('.quote-location__checkbox').checked)
      .map(loc => ({
        name        : loc.querySelector('.quote-location__checkbox').value,
        placement   : loc.querySelector('.quote-location__placement')?.value || '',
        namesNumbers: loc.querySelector('.quote-location__names-numbers')?.checked || false,
      }));

    // Artwork + color data from step 3 detail cards
    return step2Locs.map(base => {
      const card     = this.modal.querySelector(`.quote-location-detail[data-location="${CSS.escape(base.name)}"]`);
      const fileInput = card?.querySelector('.quote-location__file-input');
      const colorSel  = card?.querySelector('.quote-location__color-count--sp');
      const wbCb      = card?.querySelector('.quote-location__white-base');
      const dtfSel    = card?.querySelector('.quote-location__dtf-size');
      return {
        ...base,
        colorCount : parseInt(colorSel?.value || '1'),
        filename   : fileInput?.files[0]?.name || '',
        fileUrl    : fileInput?.dataset.uploadedUrl || '',
        whiteBase  : wbCb?.checked || false,
        dtfSize    : dtfSel?.value || DTF_SIZES[0],
      };
    });
  }

  _getItems() {
    this._flushStep1DOM();
    const items = [];
    Object.entries(this._step1Quantities).forEach(([color, sizeMap]) => {
      Object.entries(sizeMap).forEach(([size, qty]) => {
        if (!qty) return;
        const variant = this._findVariant(size, color || null);
        if (variant) items.push({ variantId: variant.id, size, color, price: variant.price, quantity: qty });
      });
    });
    return items;
  }

  _findVariant(size, color) {
    const { variants, size_option_index, color_option_index } = this.product;
    return variants.find((v) => {
      const sizeMatch  = v.options[size_option_index] === size;
      const colorMatch = !color || v.options[color_option_index] === color;
      return sizeMatch && colorMatch;
    }) || null;
  }

  _getRepeatOrderInfo() {
    const cb  = document.getElementById(`QuoteRepeatOrder-${this.sectionId}`);
    const ref = document.getElementById(`QuoteRepeatRef-${this.sectionId}`);
    return {
      isRepeat : cb?.checked || false,
      reference: ref?.value.trim() || '',
    };
  }

  // ── Pricing ─────────────────────────────────────────────────────

  _calcPricing() {
    const items     = this._getItems();
    const locations = this._getLocations();
    const totalQty  = items.reduce((s, i) => s + i.quantity, 0);

    // No separate bulk discount: quantity pricing is built into the print price tables.
    const garmentDiscount = 0;

    const garmentCost = items.reduce((s, i) => s + (i.price / 100) * i.quantity, 0);

    let printCostPerPiece = 0;
    let setupCost = 0;
    let printCostTotal = 0;

    // Locations with Names & Numbers bypass the standard print charge
    const billablePrintLocs = locations.filter(l => !l.namesNumbers);

    if (this._printType === 'dtf') {
      printCostPerPiece = billablePrintLocs.reduce((s, l) => s + dtfPricePerPiece(l.dtfSize, totalQty), 0);
      setupCost         = 0;
      printCostTotal    = printCostPerPiece * totalQty;
    } else {
      printCostPerPiece = billablePrintLocs.reduce((s, l) => s + spPricePerPiece(l.colorCount, totalQty), 0);
      setupCost         = billablePrintLocs.reduce((s, l) => s + 45 * l.colorCount, 0);
      printCostTotal    = printCostPerPiece * totalQty;
    }

    const whiteBaseLocs = locations.filter((l) => l.whiteBase).length;
    const whiteBaseCost = whiteBaseLocs * totalQty;

    const nnLocs     = locations.filter((l) => l.namesNumbers);
    const nnLocCount = nnLocs.length;
    const nnCost     = nnLocCount * totalQty * 10;

    const subtotalBeforeDiscount = garmentCost + printCostTotal + setupCost + whiteBaseCost + nnCost;
    const discountAmount = subtotalBeforeDiscount * garmentDiscount;
    const subtotal = subtotalBeforeDiscount - discountAmount;

    return { items, locations, totalQty, garmentDiscount, garmentCost, printCostPerPiece, printCostTotal, setupCost, whiteBaseLocs, whiteBaseCost, nnLocCount, nnLocs, nnCost, subtotalBeforeDiscount, discountAmount, subtotal };
  }

  // ── Submit ──────────────────────────────────────────────────────

  async _submit() {
    const btn = document.getElementById(`QuoteSubmitBtn-${this.sectionId}`);
    const p   = this._calcPricing();

    if (p.items.length === 0) {
      this._goTo(1);
      return;
    }

    if (btn) { btn.disabled = true; btn.textContent = 'Processing…'; }

    const notes      = document.getElementById(`QuoteNotes-${this.sectionId}`)?.value?.trim() || '';
    const designName = document.getElementById(`QuoteDesignName-${this.sectionId}`)?.value?.trim() || '';
    const repeat     = this._getRepeatOrderInfo();
    const isDTF      = this._printType === 'dtf';

    const locLabel = p.locations.map((l) => {
      const artworkNote = l.fileUrl
        ? ` — Artwork: ${l.fileUrl}`
        : l.filename ? ` — Artwork: ${l.filename} (not uploaded)` : '';
      const colorInfo  = isDTF ? ` (${l.dtfSize})` : ` (${l.colorCount} color${l.colorCount > 1 ? 's' : ''})`;
      const placement  = l.placement ? ` [${l.placement}]` : '';
      const wb         = l.whiteBase ? ' [White Base]' : '';
      return `${l.name}${placement}${colorInfo}${wb}${artworkNote}`;
    }).join(', ');

    const sharedProps = Object.fromEntries(
      Object.entries({
        'Design Name'      : designName,
        'Print Method'     : isDTF ? 'DTF (Direct to Film)' : 'Screen Printing',
        'Print Locations'  : locLabel,
        'Print Cost'       : isDTF ? `$${p.printCostPerPiece.toFixed(2)}/pc (DTF)` : `$${p.printCostPerPiece.toFixed(2)}/pc`,
        'Setup Fee'        : p.setupCost > 0 ? `$${p.setupCost.toFixed(2)}` : '',
        'White Base Cost'  : p.whiteBaseCost > 0 ? `$${p.whiteBaseCost.toFixed(2)} ($1/pc × ${p.whiteBaseLocs} location${p.whiteBaseLocs > 1 ? 's' : ''})` : '',
        'Bulk Discount'    : p.garmentDiscount > 0 ? `${(p.garmentDiscount * 100).toFixed(0)}%` : '',
        'Repeat Order'     : repeat.isRepeat ? `Yes${repeat.reference ? ` — ${repeat.reference}` : ''}` : '',
        'Names & Numbers'  : p.nnCost > 0 ? `Yes — ${p.nnLocs.map(l => l.name).join(', ')} (+$${p.nnCost.toFixed(2)})` : '',
        'Full Invoice Total': `$${p.subtotal.toFixed(2)}`,
        'Designer Notes'   : notes,
      }).filter(([, v]) => v)
    );

    const cartItems = p.items.map((i) => ({
      id: i.variantId,
      quantity: i.quantity,
      properties: { ...sharedProps },
    }));

    const printAndSetupTotal = Math.round((p.printCostTotal + p.setupCost + p.whiteBaseCost + p.nnCost) * (1 - p.garmentDiscount));
    if (PRINT_SERVICE_VARIANT_ID && printAndSetupTotal > 0) {
      const serviceParts = [];
      if (p.printCostTotal > 0 || p.setupCost > 0) serviceParts.push(isDTF ? 'DTF Print + Setup' : 'Screen Print + Setup');
      if (p.nnCost > 0) serviceParts.push('Names & Numbers');
      cartItems.push({
        id: PRINT_SERVICE_VARIANT_ID,
        quantity: printAndSetupTotal,
        properties: Object.fromEntries(
          Object.entries({
            'Service'        : serviceParts.join(' + '),
            'Print Cost'     : `$${p.printCostTotal.toFixed(2)}`,
            'Setup Fee'      : `$${p.setupCost.toFixed(2)}`,
            'Names & Numbers': p.nnCost > 0 ? `$${p.nnCost.toFixed(2)} ($10/pc × ${p.nnLocCount} side${p.nnLocCount > 1 ? 's' : ''} × ${p.totalQty} pcs)` : '',
          }).filter(([, v]) => v)
        ),
      });
    }

    const orderNote = this._buildOrderNote(p, designName, notes, locLabel, repeat, isDTF);

    try {
      let blockedItems = [];
      const bulkResp = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method : 'POST',
        headers: { 'Content-Type': 'application/json' },
        body   : JSON.stringify({ items: cartItems }),
      });

      if (!bulkResp.ok) {
        for (const item of cartItems) {
          const r = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method : 'POST',
            headers: { 'Content-Type': 'application/json' },
            body   : JSON.stringify({ items: [item] }),
          });
          if (!r.ok) blockedItems.push(item);
        }
      }

      const hasStockWarning = blockedItems.length > 0;

      this._sendNotificationEmail(orderNote).catch(() => {});

      const cartAttributes = Object.fromEntries(
        Object.entries({
          'Print Method' : isDTF ? 'DTF' : 'Screen Printing',
          'Repeat Order' : repeat.isRepeat ? `Yes${repeat.reference ? ` — ${repeat.reference}` : ''}` : '',
          ...(hasStockWarning ? { 'Stock Note': 'Some items may be out of stock — store to confirm' } : {}),
        }).filter(([, v]) => v)
      );

      await fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method : 'POST',
        headers: { 'Content-Type': 'application/json' },
        body   : JSON.stringify({ note: orderNote, attributes: cartAttributes }),
      });

      const checkoutUrl = '/cart';

      if (hasStockWarning) {
        if (btn) { btn.disabled = false; btn.textContent = 'Proceeding to cart…'; }
        const summaryBody = document.getElementById(`QuoteSummaryBody-${this.sectionId}`);
        const totals      = document.getElementById(`QuoteTotals-${this.sectionId}`);
        if (summaryBody) summaryBody.insertAdjacentHTML('afterbegin', `
          <div style="background:#fff8e1;border:1px solid #f0c040;border-radius:4px;padding:10px 14px;margin-bottom:14px;font-size:.85rem;color:#7a5a00;">
            &#9888; Some items chosen might be out of stock and might cause delays.
            Your quote request has been sent — we will confirm availability.
          </div>`);
        if (totals) totals.style.display = 'none';
        setTimeout(() => { window.location.href = checkoutUrl; }, 2500);
      } else {
        window.location.href = checkoutUrl;
      }

    } catch (err) {
      console.error('Quote submit error:', err);
      this._showError(`Could not submit quote: ${err.message}. Please try again.`, 5);
      if (btn) { btn.disabled = false; btn.textContent = 'Add to Cart'; }
    }
  }

  // ── Order note ──────────────────────────────────────────────────

  _buildOrderNote(p, designName, notes, locLabel, repeat, isDTF) {
    const printMethodLabel = isDTF ? 'DTF (Direct to Film)' : 'Screen Printing';
    return [
      '=== QUOTE REQUEST ===',
      '',
      `Product      : ${this.product.title}`,
      `Print Method : ${printMethodLabel}`,
      designName ? `Design Name  : ${designName}` : null,
      `Locations    : ${locLabel}`,
      notes ? `Designer Notes: ${notes}` : null,
      repeat.isRepeat ? `Repeat Order : Yes${repeat.reference ? ` — ${repeat.reference}` : ''}` : null,
      '',
      '--- Sizes & Quantities ---',
      ...p.items.map((i) => `${i.color ? i.color + ' / ' : ''}${i.size}: ${i.quantity} pcs`),
      '',
      '--- Pricing (Full Invoice) ---',
      `Total Pieces : ${p.totalQty}`,
      `Garments     : $${p.garmentCost.toFixed(2)}`,
      isDTF
        ? `DTF Printing : $${p.printCostTotal.toFixed(2)} ($${p.printCostPerPiece.toFixed(2)}/pc)`
        : `Printing     : $${p.printCostTotal.toFixed(2)} ($${p.printCostPerPiece.toFixed(2)}/pc)`,
      p.setupCost > 0     ? `Setup Fee    : $${p.setupCost.toFixed(2)}` : null,
      p.whiteBaseCost > 0 ? `White Base   : $${p.whiteBaseCost.toFixed(2)} ($1/pc × ${p.whiteBaseLocs} location${p.whiteBaseLocs > 1 ? 's' : ''})` : null,
      p.nnCost > 0        ? `Names & Nums : $${p.nnCost.toFixed(2)} (${p.nnLocCount} side${p.nnLocCount > 1 ? 's' : ''} × $10/pc × ${p.totalQty} pcs) — sides: ${p.nnLocs.map(l => l.name).join(', ')}` : null,
      p.discountAmount > 0 ? `Bulk Discount: ${(p.garmentDiscount * 100).toFixed(0)}% off entire order = -$${p.discountAmount.toFixed(2)}` : null,
      `FULL TOTAL   : $${p.subtotal.toFixed(2)}`,
      ...(() => {
        const nnData = this._getNNData();
        if (!nnData.length) return [];
        const fileEl  = document.getElementById(`QuoteNNFile-${this.sectionId}`);
        const fileUrl = fileEl?.dataset.uploadedUrl || '';
        const lines   = ['', '--- Names & Numbers ---'];
        if (fileUrl) lines.push(`Uploaded file: ${fileUrl}`);
        nnData.forEach(row => {
          const sides = Object.entries(row).filter(([k]) => k !== 'row' && k !== 'size').map(([k, v]) => `${k}: ${v || '—'}`).join(' | ');
          lines.push(`Row ${row.row} (${row.size}): ${sides}`);
        });
        return lines;
      })(),
    ].filter((l) => l !== null).join('\n');
  }

  // ── Notification email ──────────────────────────────────────────

  async _sendNotificationEmail(bodyText) {
    const form = document.getElementById(`QuoteContactForm-${this.sectionId}`);
    if (!form) return;
    document.getElementById(`QuoteContactEmail-${this.sectionId}`).value = 'payments@greenscreenyukon.com';
    document.getElementById(`QuoteContactName-${this.sectionId}`).value  = 'Quote Request';
    document.getElementById(`QuoteContactPhone-${this.sectionId}`).value = '';
    document.getElementById(`QuoteContactBody-${this.sectionId}`).value  = bodyText;
    const formData = new FormData(form);
    await fetch(form.action || '/contact', { method: 'POST', body: formData });
  }

  // ── File upload ─────────────────────────────────────────────────

  async _uploadFile(file) {
    const data = new FormData();
    data.append('file', file);
    data.append('upload_preset', QUOTE_CLOUDINARY_PRESET);
    const resp = await fetch(
      `https://api.cloudinary.com/v1_1/${QUOTE_CLOUDINARY_CLOUD}/auto/upload`,
      { method: 'POST', body: data }
    );
    if (!resp.ok) throw new Error(`Cloudinary ${resp.status}`);
    const json = await resp.json();
    return json.secure_url;
  }

  // ── Names & Numbers helpers ─────────────────────────────────────

  _getNNData() {
    const grid = document.getElementById(`QuoteNNGrid-${this.sectionId}`);
    if (!grid) return [];
    const rows = [];
    grid.querySelectorAll('tbody tr').forEach((tr, idx) => {
      const sizeEl = tr.querySelector('.quote-nn__td--size');
      const inputs = tr.querySelectorAll('.quote-nn__input');
      if (!inputs.length) return;
      const row = { row: idx + 1, size: sizeEl?.textContent.trim() || '' };
      inputs.forEach(inp => { row[inp.dataset.location] = inp.value.trim(); });
      rows.push(row);
    });
    return rows;
  }

  _parseCSV(text) {
    const lines = text.split(/\r?\n/).map(l => l.trim()).filter(Boolean);
    if (lines.length < 2) return [];
    const headers = lines[0].split(',').map(h => h.replace(/^"|"$/g, '').trim().toLowerCase());
    return lines.slice(1).map(line => {
      const vals = line.split(',').map(v => v.replace(/^"|"$/g, '').trim());
      const row = {};
      headers.forEach((h, i) => { row[h] = vals[i] || ''; });
      return row;
    });
  }

  _applyCSVToGrid(csvData) {
    const grid = document.getElementById(`QuoteNNGrid-${this.sectionId}`);
    if (!grid) return;
    const trs = grid.querySelectorAll('tbody tr');
    csvData.forEach((csvRow, idx) => {
      if (idx >= trs.length) return;
      trs[idx].querySelectorAll('.quote-nn__input').forEach(inp => {
        const loc = inp.dataset.location.toLowerCase();
        const val = csvRow[loc] || csvRow['name/number'] || csvRow['name'] || csvRow['number'] || csvRow['names/numbers'] || '';
        inp.value = val;
        const rid   = inp.dataset.rowId;
        const lname = inp.dataset.location;
        if (!this._nnData[rid]) this._nnData[rid] = {};
        this._nnData[rid][lname] = val;
      });
    });
  }

  // ── HTML escape ─────────────────────────────────────────────────

  _esc(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }
}

// Boot all modals on page
document.querySelectorAll('.quote-modal').forEach((el) => new QuoteModal(el));

// Trigger button opens the correct modal
document.addEventListener('click', (e) => {
  const trigger = e.target.closest('[data-open-quote-modal]');
  if (!trigger) return;
  const id    = trigger.dataset.openQuoteModal;
  const modal = document.getElementById(`QuoteModal-${id}`);
  if (modal?._quoteModal) modal._quoteModal.open();
});
